import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import authHelper from 'helpers/auth';
import configHelper from 'helpers/config';
import translate from 'components/hoc/translate';

class BookingToolContainer extends React.Component {
    state = {
        error: false,
    }

    componentDidMount() {
        if (authHelper.isReseller()) {
            this.generateScript();
        }
    }

    generateUrl = () => {
        const bookingToolUrl = configHelper.getBookingToolUrl();

        if (!bookingToolUrl) {
            this.setState({
                error: true,
            });
            return;
        }

        return `${ bookingToolUrl }/bundle.js`;
    }

    generateScript = () => {
        const url = this.generateUrl();
        const script = document.createElement('script');

        script.src = `${ url }`;
        document.body.appendChild(script);
    }

    render() {
        if (!authHelper.isReseller() || !authHelper.isEnabled() || this.state.error) {
            return (
                <Card>
                    <CardText>
                        <h1>{ this.props.translate('pages.booking_tool.not_available.title') }</h1>

                        <p>{ this.props.translate('pages.booking_tool.not_available.text') }</p>
                    </CardText>
                </Card>
            );
        }

        return <div id='booking-tool'></div>;
    }
}

BookingToolContainer.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default translate(BookingToolContainer);



// WEBPACK FOOTER //
// ./src/pages/booking-tool/BookingToolContainer.js